import {
  useBillingHistory,
  useCancelSubscription,
} from "@/api/hooks/use-query-api";
import { usePaymentMethodUpdate } from "@/api/hooks/use-subscription";
import { useBillingStore } from "../store/billing-store";
import { usePricingActions } from "@/features/pricing/hooks/use-pricing-actions";
import mixpanel from "mixpanel-browser";

export const useBilling = () => {
  // API Hooks
  const {
    data: billingData,
    isLoading: isBillingLoading,
    error: billingError,
    refetch: refetchBillingData,
  } = useBillingHistory();

  const { mutate: cancelSubscription, isPending: isCancellingSubscription } =
    useCancelSubscription();

  const { getPaymentMethodUpdateUrl, isLoading: isPaymentMethodUpdateLoading } =
    usePaymentMethodUpdate();

  // Pricing Actions Hook
  const { openPricingModal, openPricingModalWithTopup } = usePricingActions();

  // Store Hook
  const { isCancelDialogOpen, openCancelDialog, closeCancelDialog } =
    useBillingStore();

  // Actions
  const handleCancelSubscription = async (reason: string) => {
    try {
      // Cancel subscription API'yi çağır
      cancelSubscription(reason, {
        onSuccess: () => {
          closeCancelDialog();
          // Toast notification eklenebilir
          console.log("Subscription cancelled successfully", { reason });
        },
        onError: (error) => {
          console.error("Failed to cancel subscription:", error);
          // Error toast notification eklenebilir
        },
      });
    } catch (error) {
      console.error("Failed to cancel subscription:", error);
    }
  };

  const handleUpgrade = async () => {
    try {
      // PricingModal'ı monthly tab'ında aç
      openPricingModal();
    } catch (error) {
      console.error("Failed to open pricing modal:", error);
    }
  };
  const handleUpgradeToTopup = async () => {
    try {
      // PricingModal'ı topup tab'ında aç
      openPricingModalWithTopup();
    } catch (error) {
      console.error("Failed to open pricing modal:", error);
    }
  };

  const handleKeepPlan = () => {
    closeCancelDialog();
  };

  const handleEditPaymentMethod = async () => {
    try {
      mixpanel.track("payment_method_clicked");
      const response = await getPaymentMethodUpdateUrl();

      if (response?.data?.url) {
        // Customer portal URL'e navigate et
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error("Failed to get payment method update URL:", error);
      // Error toast notification eklenebilir
    }
  };

  return {
    // Data
    billingData,
    isBillingLoading,
    billingError,

    // Loading States
    isCancellingSubscription,
    isPaymentMethodUpdateLoading,

    // Modal States
    isCancelDialogOpen,

    // Modal Actions
    openCancelDialog,
    closeCancelDialog,

    // Business Actions
    handleEditPaymentMethod,
    handleCancelSubscription,
    handleUpgrade,
    handleUpgradeToTopup,
    handleKeepPlan,

    // Utility
    refetchBillingData,
  };
};
